<template>
  <div>
    <b-navbar-nav>
      <b-nav-item to="/profile"
        ><i class="fas fa-tachometer-alt"></i>Dashboard</b-nav-item
      >
      <b-nav-item to="/profile/orders"
        ><i class="fas fa-cart-arrow-down"></i>Orders</b-nav-item
      >
      <b-nav-item to="/profile/wedding-lists"
        ><i class="fa fa-gift"></i>Gift List</b-nav-item
      >
      <b-nav-item to="/profile/addresses"
        ><i class="fas fa-map-marker-alt"></i>Addresses</b-nav-item
      >
      <b-nav-item to="/profile/account-details"
        ><i class="fas fa-user"></i>Account details</b-nav-item
      >
      <b-nav-item to="/logout"
        ><i class="fas fa-sign-out-alt"></i>Logout</b-nav-item
      >
    </b-navbar-nav>
  </div>
</template>

<script>
export default {
  name: "Account-Sidebar",
  data() {
    return {};
  },

  methods: {},
};
</script>
